import { SET_USER, UPDATE_USER } from "../actions/actionTypes";

const initialState = {
  user: null,
  pastOrders: [],
  addresses: [],
  loading: false,
};

export default (state = initialState, { type, payload }) => {
  let newUser = null;
  let newAddresses = [];
  let index = null;
  switch (type) {
    case "PROFILE_LOADING":
      return { ...state, loading: true };
    case SET_USER:
      if (!payload) {
        return {
          ...state,
          user: null,
          pastOrders: [],
          address: null,
          loading: false,
        };
      } else
        return {
          ...state,
          user: payload.user,
          addresses: payload.addresses || [],
          loading: false,
        };

    
    case UPDATE_USER:
      newUser = state.user;
      newUser = { ...newUser, ...payload.user };

      newAddresses = state.addresses || [];
      if (payload.address) {
        newAddresses = [
          ...newAddresses
            .map((a) => ({ ...a, is_preferred: false }))
            .filter((a) => a.id !== payload.delete_address),
          { ...payload.address, is_preferred: true },
        ];
      }
      return {
        ...state,
        user: newUser,
        addresses: newAddresses,
      };

    case "MAKE_ADDRESS_PREFERRED":
      newAddresses = state.addresses || [];
      newAddresses = newAddresses.map((a) =>
        a.id == payload
          ? { ...a, is_preferred: true }
          : { ...a, is_preferred: false }
      );
      return { ...state, addresses: newAddresses };

    case "DELETE_ADDRESS":
      newAddresses = state.addresses || [];
      newAddresses = newAddresses.filter((a) => a.id !== payload.id);
      if (payload.new_preferred)
        newAddresses = newAddresses.map((a) => {
          if (a.id == payload.new_preferred)
            return { ...a, is_preferred: true };
          return a;
        });
      return { ...state, addresses: newAddresses };

    case "CLEAR_USER":
      return {
        user: null,
        pastOrders: [],
        addresses: [],
        loading: false,
      };
    case "REMOVE_FAVORITE_PRODUCT": {
      const newUser = state.user;
      const { productId } = payload;
      newUser.favorite_products = newUser.favorite_products.filter(
        (favorite) => favorite.product__id !== productId
      );
      return {
        ...state,
        user: newUser,
      };
    }
    case "ADD_FAVORITE_PRODUCT": {
      const { productId, id } = payload;
      const newUser = {
        ...state.user,
        favorite_products: [
          ...state.user.favorite_products,
          { product__id: productId, id: id },
        ],
      };

      return {
        ...state,
        user: newUser,
      };
    }

    case "FETCH_FAVORITE_PRODUCT": {
      const { data } = payload;
      const newUser = {
        ...state.user,
        favorite_products_list: data,
      };

      return {
        ...state,
        user: newUser,
      };
    }

    default:
      return state;
  }
};
